import { newYammerPostAction } from '../components/NewMessageButton.locstring.json';
import type { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { ControlIcons } from 'owa-control-icons';
import isFeatureEnabled from 'owa-feature-flags/lib/utils/isFeatureEnabled';
import loc from 'owa-localize';
import initializeYammerPublisher from 'owa-mail-commands/lib/actions/initializeYammerPublisher';
import onNewYammerPost from 'owa-mail-commands/lib/actions/onNewYammerPost';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { lazyTryShowYammerPostTeachingMoment } from 'owa-yammer-post';

export function getYammerPublisherItemMenuOption(
    newMessageSplitButtonId: string
): IContextualMenuItem | null {
    if (!isFeatureEnabled('tri-newYammerPostButton')) {
        return null;
    }

    // This option will be false when user either doesn't have a Yammer license or is not mapped
    //
    // remarks --- this follows N-1 pattern meaning the value is checked and updated after each boot if needed. More details below:
    // During boot, use pre-cached HasYammerLicense value from UserOptions to determine if the license is available or not (default is false).
    // After boot, perform yammer call to check for license (and provision user on yammer on the fly if needed).
    // If needed, update HasYammerLicense both in memory to enable/disable the button and cache value for next bootup (on the server).
    if (!getUserConfiguration()?.UserOptions?.HasYammerLicense) {
        return null;
    }

    lazyTryShowYammerPostTeachingMoment.importAndExecute(newMessageSplitButtonId);

    // TODO: check if post to yammer from was disabled by tenant admin

    return {
        key: 'yammerPost',
        text: loc(newYammerPostAction),
        iconProps: { iconName: ControlIcons.YammerLogo },
        onClick: onNewYammerPost,
        onMouseOver: initializeYammerPublisher,
    };
}
